import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { resetData } from "../../features/data/data.slice";
import { resetFiles } from "../../features/fileUpload/fileUpload.slice";
import { resetSteps } from "../../features/stepper.slice";
import { resetSubmition } from "../../features/submition/submition.slice";
import { resetUser } from "../../features/user/user.slice";

function Home() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetData());
    dispatch(resetSteps());
    dispatch(resetUser());
    dispatch(resetSubmition());
  }, []);

  return <Navigate to={"/choose-path"} />;
}

export default Home;
